import {AreaConfigLucky, LuckyType, SpriteConfigLucky, SpriteConfigNameLucky} from "@/entities/lucky/types";

import {PreloadedImages} from "@/shared/utils/preload";

export const LUCKY_LAYOUT = {
    //Отступ у контейнера
    padding: 40,
    //Отступ сверху
    topPadding: 80,
    //Отступ снизу
    bottomPadding: 140,


    //Количество секторов
    sectorsCount: 8,
} as const


export const AREA: AreaConfigLucky = {
    width: 350,
    height: 436,
    baseWidth: 350,
    baseHeight: 436,
    x: 0,
    y: 0,
}


export const createSprites = (): SpriteConfigLucky[] => [
    {
        name: SpriteConfigNameLucky.wheel,
        width: 0,
        height: 0,
        x: 0,
        y: 0,
        anchor: 0.5,
        image: PreloadedImages.wheel?.src ?? '',
        baseWidth: 350,
        baseHeight: 350,
    },
    {
        name: SpriteConfigNameLucky.stick,
        width: 0,
        height: 0,
        x: 0,
        y: 0,
        anchor: 0.5,
        image: PreloadedImages.stick?.src ?? '',
        baseWidth: 211.5,
        baseHeight: 234.5,

    },
    {
        name: SpriteConfigNameLucky.center,
        width: 0,
        height: 0,
        x: 0,
        y: 0,
        anchor: 0.5,
        image: PreloadedImages.center?.src ?? '',
        baseWidth: 61.8,
        baseHeight: 62.4,

    }
];

export const SECTORS:Record<LuckyType, Record<number, number>> = {
    [LuckyType.ENERGY]: {8:1,5:3,1:5,10:7,15:2,20:0,18:4},
    [LuckyType.EMPTY_NET_10]: {},
    [LuckyType.EMPTY_NET_25]: {},
    [LuckyType.OVI_FLEX_100]: {1:6}
}

